import { AggregateRatingsProps } from '../types'

const getRating = (aggregateRatings: AggregateRatingsProps) => {
  const rating = aggregateRatings
    ? {
      amount: aggregateRatings.overall.count,
      value: aggregateRatings.overall.rating,
      onClick: () => {},
    }
    : undefined

  return rating
}

export default getRating


